import styled from 'styled-components';

export const CardsPictoWrapper = styled.div`
    span + span,
    svg + svg {
        margin-left: 5px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CardsPictoStyle.js